/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.feature.store.rpc.PriorityFeaturesRpc
 */

/**
 * Record for com.hubspot.chirp.core.CausalChainLink
 */

/**
 * Record for com.hubspot.chirp.core.ChirpMethodCoordinates
 */

export const getPriorityFeaturesRpc = {
  serviceName: 'com.hubspot.feature.store.rpc.PriorityFeaturesRpc',
  rpcName: 'getPriorityFeatures',
  auth: 'external',
  fingerprint: 'M3RtdDWHlQqAPKUccazxbpwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getPriorityFeaturesBulkRpc = {
  serviceName: 'com.hubspot.feature.store.rpc.PriorityFeaturesRpc',
  rpcName: 'getPriorityFeaturesBulk',
  auth: 'external',
  fingerprint: 'cA7-oI0JXgsxu6vygGDqF5wP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};